import cn from 'classnames';
import { Typography } from '@snack-uikit/typography';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Expert(_ref) {
  var image = _ref.image,
    name = _ref.name,
    surname = _ref.surname,
    jobTitle = _ref.jobTitle,
    className = _ref.className;
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.expert, className),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.imageWrapper,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.imageBackground
      }), /*#__PURE__*/_jsx("img", {
        src: image,
        alt: "expert",
        className: styles.image
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.personalDetails,
      children: [/*#__PURE__*/_jsx(Typography.SansTitleL, {
        className: styles.detailsColor,
        children: name
      }), /*#__PURE__*/_jsx(Typography.SansTitleL, {
        className: styles.detailsColor,
        children: surname
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.jobTitle,
      children: /*#__PURE__*/_jsx(Typography.SansBodyM, {
        className: styles.detailsColor,
        children: jobTitle
      })
    })]
  });
}